import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { Rating } from '@medprev-web-app/api-graphql-client';

import { Icon } from '@/components/ui/icon.component';

interface EntityBarProps {
  rating: Rating;
}

const tiersMap = {
  one: '1',
  two: '2',
  three: '3',
  four: '4',
  five: '5',
};

export function EntityBar({ rating }: EntityBarProps) {
  const { tiers = {} } = rating.fiveStars;

  const stars = (Object.keys(tiers) as Array<keyof typeof tiers>)
    .map((key) => {
      return {
        key: tiersMap[key],
        value: tiers[key],
      };
    }).filter((star) => star.key)
    .reverse();

  return (
    <div className="w-full" data-testid={DataTestIdEnum.ENTITY_BAR}>
      {stars.map((star) => {
        const value = typeof star.value === 'number' && !isNaN(star.value) ? star.value : 0;
        const count = typeof rating.fiveStars.count === 'number' && !isNaN(rating.fiveStars.count) && rating.fiveStars.count > 0 ? rating.fiveStars.count : 1;
        const widthPercent = (value / count) * 100;
        const hasStarValue = typeof star.value === 'number' && star.value > 0;

        return (
          <div key={star.key} className="w-full" aria-label="Estrelas" id={`progress-bar-${star.key}`}>
            <div className="flex items-center gap-3">
              <div className="flex flex-grow items-center gap-1">
                <span className="text-gray-600 text-sm mt-1">{star.key}</span>

                <Icon icon={faStar} className="text-warning-400" />
              </div>

              <div className="relative w-full">
                <div className="h-2.5 w-full bg-gray-200 rounded-xl" />
                {hasStarValue && (
                  <div
                    style={{ width: `${widthPercent}%` }}
                    className="h-2.5 rounded-xl bg-warning-400 absolute top-0 bottom-0"
                    role="progressbar"
                    aria-valuenow={widthPercent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                    aria-label="Estrelas progresso"
                  />
                )}
              </div>

              <div className="flex-1  flex w-4">
                <span className="text-gray-600 text-sm">
                  (
                  {star.value}
                  )
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
